import { h, render } from 'preact';
import Palava from './Palava';

const base = document.querySelector('#base');
if (!base) throw new Error(`No base?!`);

render(<Palava/>, base);
